/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import {  Node } from '@msdyn365-commerce-modules/utilities';
import * as React from "react";
import { useRef, useEffect } from "react";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { IObrienProductHeaderViewProps } from "./obrien-product-header";

export default (props: IObrienProductHeaderViewProps) => {

  let animateThis1 = useRef(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    gsap.to( animateThis1, {
        scrollTrigger: {
            trigger: '.single-header-2020', 
            start: "top top",
            scrub: 1,
        },
        duration: 2,
        x: '0',
        y: '160',
        ease: "linear",
    })
    
  }, [])

  const { 
    obProductImage, 
    imageContainer,
    content,
    heading,
    links
  } = props;

  
  return (
    <>
      <div className="single-header-2020"
        ref={el => {
        //@ts-ignore
        animateThis1 = el}}
      >
        <div>
          {heading ? (
            <div className='ob-product-header-text flex-vertical'>
              <div className='ob-title'>
                {heading}
              </div>
            </div>
          ) : null}
          {content ? (
          <div className='ob-product-header-text flex-vertical'>
            <div className='inside-lg text-center'>
              {content}
              {links}
            </div>
          </div>
          ) : null}
          <Node {...imageContainer}>{obProductImage}</Node>
        </div>
      </div>
    </>
  );
};
